import React from 'react'

function Divider() {
  return (
<div className='my-3 col-span-full border-t border-b border-b-fuchsia-600/40  border-t-orange-300/40
' />
  )
}

export default Divider